export default "__VITE_ASSET__jpgnu_CT__ 100w";